import { render, staticRenderFns } from "./TextbookIssuesIndex.vue?vue&type=template&id=a5cbcede&"
import script from "./TextbookIssuesIndex.vue?vue&type=script&lang=ts&"
export * from "./TextbookIssuesIndex.vue?vue&type=script&lang=ts&"
import style0 from "./TextbookIssuesIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports